module.exports = __webpack_public_path__ + "img/Eduzz-9-en.30d7eaa0.png";